import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import {
    DaysOfWeek,
    ServiceCenterStatus,
    StorageType,
} from 'app/enums/label.enums'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import ServiceCenterForm from '../ServiceCenterForm'
import {
    OperationalHour,
    StorageTableType,
} from '../serviceCenters.types'

const ServiceCenterCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const operationalHours: OperationalHour[] = Object.keys(DaysOfWeek).map((day) => {
        return {
            isOperational: !(day === DaysOfWeek.SATURDAY || day === DaysOfWeek.SUNDAY),
            dayOfWeek: day,
            workStartsAt: undefined,
            workEndsAt: undefined,
        } as OperationalHour
    })

    return (
        <ServiceCenterForm
            data={{
                isAvailableForDropoff: true,
                isAvailableForPickup: true,
                storages: [
                    {
                        storageCapacity: 0,
                        storageType: StorageType.DRY,
                    },
                    {
                        storageCapacity: 0,
                        storageType: StorageType.C,
                    },
                ] as StorageTableType[],
                serviceCenterStatus: ServiceCenterStatus.PLANNED,
                enhancedSkyCenterScanning: true,
                orderSelectionDelay: 2,
                operationalHours,
            }}
            onSuccess={onSuccess}
            exists={false}
            requestParam={request.create()}
        />
    )
}

export default ServiceCenterCreate
